import { create, select, Selection } from "d3";
import { UIUtilGeneral } from "../util/Util";

export interface IGroupedCheckListConfig {
    Parent: HTMLElement;
    Data?: IGeneralItemList[];
}

interface IGeneralItemList {
    ValueMember: number;
    GroupedList: IGroupedList[];
    DisplayMember: string;
}

interface IGroupedList {
    ValueMember: number;
    Checked: boolean;
    DisplayMember: string;
}

export class GroupedCheckList {
    private listContainer: Selection<HTMLDivElement, any, HTMLElement, null>;
    private config: IGroupedCheckListConfig;
    private dataItems: Map<number, IGeneralItemList>;

    constructor(config: IGroupedCheckListConfig) {
        this.config = config;
        this.dataItems = new Map();
        this.CreateElements();
    }


    private CreateElements() {
        this.listContainer = select(this.config.Parent).append("div");
        this.listContainer.classed("grouped_list_container", true);
        this.listContainer.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);

        if (this.config.Data) {
            this.UpdateData(this.config.Data);
        }
    }

    public UpdateData(datos: IGeneralItemList[]) {
        this.dataItems.clear();
        datos.forEach(d => {
            this.dataItems.set(d.ValueMember, d);
        });
        this.UpdateItemsListView();
    }

    private UpdateItemsListView() {
        this.listContainer
            .selectAll<HTMLDivElement, IGeneralItemList>(":scope > .list_general_item")
            .data(this.getDataList(), d => d.ValueMember)
            .join(
                enter => this.UpdateItemListView(enter.append(() => this.CreateListGeneralItem().node())),
                update => this.UpdateItemListView(update),
                exit => exit.remove()
            )
    }

    private CreateListGeneralItem() {
        let item = create("div");
        item.classed("list_general_item", true);
        item.classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
        item.append("label");
        item.append("div")
            .classed("grouped_item_list", true)
            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
        return item;
    }

    private UpdateItemListView(listGeneralItem: TSelectionHTML<"div", IGeneralItemList>) {
        listGeneralItem.each((d, i, items) => {
            let generalItem = select<HTMLDivElement, IGeneralItemList>(items[i]);
            let displayIdentifierLabel = generalItem.select<HTMLLabelElement>(":scope > label");
            displayIdentifierLabel.text(d.DisplayMember)

            let groupedListContainer = generalItem.select<HTMLLabelElement>(":scope > .grouped_item_list");
            groupedListContainer
                .selectAll<HTMLDivElement, IGroupedList>(":scope > .grouped_item")
                .data(d.GroupedList, d => d.ValueMember)
                .join(
                    enter => this.UpdateGroupedListItem(enter.append(() => this.CreateListGroupedItem().node()), d),
                    update => this.UpdateGroupedListItem(update, d),
                    exit => exit.remove()
                )
        })

        return listGeneralItem;
    }

    private CreateListGroupedItem() {
        let item = create("div");
        item.classed("grouped_item", true);
        item.classed(UIUtilGeneral.FBoxOrientation.Horizontal, true);
        item.append("label");
        item.append("input").attr("type", "checkbox");
        return item;
    }

    private UpdateGroupedListItem(listGroupedItem: TSelectionHTML<"div", IGroupedList>, dataParent: IGeneralItemList) {
        listGroupedItem.each((d, i, items) => {
            let groupedItem = select<HTMLDivElement, IGroupedList>(items[i]);
            let displayIdentifierLabel = groupedItem.select<HTMLLabelElement>(":scope > label");
            displayIdentifierLabel.text(d.DisplayMember);
            let checkInput = groupedItem.select<HTMLInputElement>(":scope > input");
            checkInput.node().checked = d.Checked;

            groupedItem.on("click", () => {
                // let parentData = this.getListGroupedItem(dataParent.ValueMember);
                /* if (d.Checked && parentData.GroupedList.filter(d => d.Checked).length <= 1) {
                    console.log("-d, Al menos uno debe de estar seleccionado");
                    return;
                } */
                d.Checked = !d.Checked;
                checkInput.property("checked", d.Checked);
            })
        })

        return listGroupedItem;
    }

    private getListGroupedItem(idItem: number) {
        return this.dataItems.get(idItem);
    }

    public getDataList() {
        return Array.from(this.dataItems.values());
    }

    public getDataListFiltered() {
        return this.getDataList().map(item => ({ ...item, GroupedList: item.GroupedList.filter(d => d.Checked) }))
    }
}